export const SET_COMPANY_NAME = "SET_COMPANY_NAME";
export const SET_COMPANY_TYPE = "SET_COMPANY_TYPE";
export const SET_EMPLOYEE_COUNT = "EMPLOYEE_COUNT";
export const RESET_BUSINESS_UNIT = "RESET_BUSINESS_UNIT";
